import React from 'react';

//Styles
import Styles from './Layout.module.scss';

const Layout = ({children}) => (
    <div className={Styles.container}>
        {children}
    </div>
);

export default Layout